export default __webpack_public_path__ + "static/3line_logo-394afcc9a47498dad6f1b9362a54e16f.svg";